'use strict';

import { GLOBAL } from './Global';
import { SEARCH_AND_LISTS as SEARCH_AND_LISTS_PERMISSION_GROUPS } from '../PermissionsGroups';

const search_and_lists = [];

for (const [key, value] of Object.entries(SEARCH_AND_LISTS_PERMISSION_GROUPS)) {
  search_and_lists.push({
    action_list: value,
    element: key,
  });
}

const SEARCH_AND_LISTS = {
  can: [
    ...GLOBAL.can,
    ...search_and_lists,
  ],
};

export {
  SEARCH_AND_LISTS,
};
